import moment from 'moment';
import { IDetailsReportFilters } from '../screens/SalesDetails/types/salesDetails';
import { BRANCHES_STATUS, ILocationReportFilters } from '../screens/SalesLocation/types/salesLocation';
import { COMPARED_PERIOD, IPeriodReportFilters } from '../screens/SalesPeriod/types/salesPeriod';
import { IReportsFilters, REPORTS_BODY_KEY } from '../types/reports';
import { localeStore } from '~/mobx/localesStore';
import { allOptionsValue, SORTING_DIRECTION } from '~/constants/main';
import { ICustomTooltipProps, TOOLTIP_DURATION } from '~/view/components/Controls/CustomTooltip/CustomTooltip';

export const defaultReportsFilters: IReportsFilters = {
  startDate: moment().startOf('month').unix(),
  endDate: moment().unix(),
  branches: [{ label: localeStore.t('all_branches'), value: allOptionsValue }],
  sortField: undefined,
  sortDir: SORTING_DIRECTION.ASCENDING,
  franchisee_branches: [],
};

export const defaultPeriodReportFilters: IPeriodReportFilters = {
  comparedPeriod: COMPARED_PERIOD.YEAR,
  startYearDate: moment().startOf('year').unix(),
  endYearDate: moment().startOf('year').add(1, 'year').unix(),
  days: [{ label: localeStore.t('every_day_of_week'), value: allOptionsValue }],
  months: [{ label: localeStore.t('all_month'), value: allOptionsValue }],
  hours: [{ label: localeStore.t('all_time_intervals'), value: allOptionsValue }],
};

export const defaultLocationReportFilters: ILocationReportFilters = {
  branches: [{ label: localeStore.t('all_branches'), value: allOptionsValue }],
  areas: [{ label: localeStore.t('all_areas'), value: allOptionsValue }],
  branchesStatus: { label: localeStore.t('active_branches'), value: BRANCHES_STATUS.ACTIVE },
};

export const defaultDetailsReportFilters: IDetailsReportFilters = {
  agents: [{ label: localeStore.t('all_agents'), value: allOptionsValue }],
  items: [{ label: localeStore.t('all_items'), value: allOptionsValue }],
  combo: [{ label: localeStore.t('combo_sales_report_all_combo_dropdown_item_name'), value: allOptionsValue }],
  orderingChannels: [{ label: 'all_channels', value: allOptionsValue }],
  paymentMethods: [{ label: 'all_methods', value: allOptionsValue }],
};

export const defaultReportsTableTitles: Record<REPORTS_BODY_KEY, string> = {
  [REPORTS_BODY_KEY.ORDERS_COUNT]: 'total_number_of_orders',
  [REPORTS_BODY_KEY.REVENUE]: 'total_revenue',
  [REPORTS_BODY_KEY.AVERAGE_CHECK]: 'average_check',
  [REPORTS_BODY_KEY.PICKUP_COUNT]: 'pick_up_number_of_orders',
  [REPORTS_BODY_KEY.PICKUP_REVENUE]: 'pick_up_revenue',
  [REPORTS_BODY_KEY.DELIVERY_COUNT]: 'delivery_number_of_orders',
  [REPORTS_BODY_KEY.DELIVERY_REVENUE]: 'delivery_revenue',
  [REPORTS_BODY_KEY.DINEIN_COUNT]: 'dine_in_number_of_orders',
  [REPORTS_BODY_KEY.DINEIN_REVENUE]: 'dine_in_revenue',

  // item sales report
  [REPORTS_BODY_KEY.ITEMS_COUNT]: 'total_number_of_items',
  [REPORTS_BODY_KEY.PICKUP_ITEMS_COUNT]: 'pick_up_number_of_items',
  [REPORTS_BODY_KEY.DELIVERY_ITEMS_COUNT]: 'delivery_number_of_items',
  [REPORTS_BODY_KEY.DINEIN_ITEMS_COUNT]: 'dine_in_number_of_items',

  //combo sales report
  [REPORTS_BODY_KEY.TOTAL_NUMBER_OF_COMBO]: 'combo_sales_report_total_number_of_combo_column_name',
  [REPORTS_BODY_KEY.PICKUP_NUMBER_OF_COMBO]: 'combo_sales_report_pickup_number_of_combo_column_name',
  [REPORTS_BODY_KEY.DELIVERY_NUMBER_OF_COMBO]: 'combo_sales_report_delivery_number_of_combo_column_name',
  [REPORTS_BODY_KEY.DINEIN_NUMBER_OF_COMBO]: 'combo_sales_report_dinein_number_of_combo_column_name',
  [REPORTS_BODY_KEY.TOTAL_COMBO_PRICE]: 'combo_sales_report_total_combo_price_column_name',
};

export const salesPeriodReportColumnTooltips: { [key in REPORTS_BODY_KEY]?: Partial<ICustomTooltipProps> } = {
  [REPORTS_BODY_KEY.REVENUE]: {
    message: 'sales_period_report_revenue_tooltip_message',
    duration: TOOLTIP_DURATION.EXTRA_LARGE,
  },
};
